import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

const sharedStyles = (tableLinkPrimary?: boolean, tableLink?: boolean) => {
  return `
    align-items: center;
    color: ${tableLinkPrimary || tableLink ? '#333' : '#2e8ece'}; 
    display: inline-flex;
    font-weight: ${tableLinkPrimary ? 600 : 400};
    position: relative;
    text-decoration: ${tableLink && !tableLinkPrimary ? 'underline' : 'none'};
    &:hover {
      color: rgb(38, 116, 169);
      text-decoration: underline;
    }
    &:focus {
      color: rgb(38, 116, 169);
    }
  `;
};

export const AngularLink = styled.a<{
  $tableLink?: boolean;
  $tableLinkPrimary?: boolean;
}>`
  ${({ $tableLinkPrimary, $tableLink }) => sharedStyles($tableLinkPrimary, $tableLink)}
`;

// css file conversion
export const StyledRouterLink = styled(RouterLink)<{
  $tableLink?: boolean;
  $tableLinkPrimary?: boolean;
}>`
  ${({ $tableLinkPrimary, $tableLink }) => sharedStyles($tableLinkPrimary, $tableLink)}
`;
